import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    notes: [
      {
        title: 'Compras del super', 
        description: 'Zanahorias, Manzanas, Avena',
        author: 'Carlos Mercado'
      },
      {
        title: 'Compras del mercado', 
        description: 'Lonja, Alitas de pollo, Carnitas', 
        author: 'Carlos Mercado'
      },
      {
        title: 'Compra de ropa', 
        description: 'Tenis, Jeans, Manga larga', 
        author: 'Sofia Reyes'
      },
      {
        title: 'Compra de ropa', 
        description: 'Tenis, Jeans, Manga larga', 
        author: 'Sofia Reyes'
      },
      {
        title: 'Compra de ropa', 
        description: 'Tenis, Jeans, Manga larga', 
        author: 'Sofia Reyes'
      }
    ]
  },
  mutations: {
    addNote(state, note){
      state.notes = [note, ...state.notes];
    }
  },
  actions: {
    addNoteAction(context, note){
      context.commit('addNote', note);
    }
  },
  modules: {
  },
  getters: {
    notes(state){
      return state.notes;
    }
  }
})
